import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import corner6 from 'assets/img/icons/spot-illustrations/corner-6.png';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Background from 'components/common/Background';

const ProjectQualities = ({ data }) => {
 return (
  <Card className="mb-3">
   <FalconCardHeader
    title="Calidades del Proyecto"
    titleTag="h5"
    className="bg-light"
    endEl={<FontAwesomeIcon icon="ellipsis-h" className="fs--2" />}
   />
   <Card.Body className="position-relative">
    <Background image={corner6} className="bg-card d-none d-md-block" />
    <Row className="g-2 fs--1">
     {data.map(({ id, value }) => (
      <Col md={6} key={id} className="d-flex gap-2">
       <FontAwesomeIcon icon="circle" transform="shrink-8" className="fs--2 mt-1" />
       <span>{value}</span>
      </Col>
     ))}
    </Row>
   </Card.Body>
  </Card>
 );
};

ProjectQualities.propTypes = {
 data: PropTypes.arrayOf(PropTypes.object)
};

export default ProjectQualities;
